// TODO(claire): swap this for your real user hook/context if you have one.
// Falls back to localStorage or empty values so the page still renders.
export function useCurrentUser(): { firstName: string; fullName: string; email: string } {
  try {
    const raw = localStorage.getItem('novala:user') || localStorage.getItem('user');
    if (raw) {
      const u = JSON.parse(raw);
      return {
        firstName: u.firstName || u.first_name || '',
        fullName: u.fullName || u.full_name || u.name || '',
        email: u.email || '',
      };
    }
  } catch {}
  return { firstName: '', fullName: '', email: '' };
}
